import * as React from 'react';
import { Badge } from '@/components/ui/badge';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

interface InterviewCardHeaderProps {
    moduleName: string;
    statusLabel: string;
    badgeVariant: BadgeVariant;
    actions?: React.ReactNode;
}

const InterviewCardHeader: React.FC<InterviewCardHeaderProps> = ({
    moduleName,
    statusLabel,
    badgeVariant,
    actions,
}) => {
    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div className="flex items-center gap-3">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                    {moduleName}
                </h3>
                <Badge variant={badgeVariant}>
                    {statusLabel}
                </Badge>
            </div>

            {actions ? (
                <div className="flex items-center gap-2">
                    {actions}
                </div>
            ) : null}
        </div>
    );
};

export default InterviewCardHeader;
